import React from 'react'
import {Divider} from 'wix-ui-tpa/cssVars'
import {classes} from './divider.st.css'

export const DividerExt = props => <Divider {...props} className={classes.root} ariaHidden />
